import {Moment} from 'moment';
import { Formacao } from './formacao.model';
import { TipoDispendio } from './tipo-dispendio.model';

export class DispendioRecursosHumanoVO {

  id: number;
  tipoDispendio: TipoDispendio;
  nomeColaborador: string;
  idEscolaridade: number;
  formacao: Formacao;
  horasTrabalhadas: number;
  valor: number;
  dataInicioAtuacao: Moment;
  dataFinalAtuacao: Moment;
  checked?: boolean;

  constructor(init?: Partial<DispendioRecursosHumanoVO>) {
    Object.assign(this, init);
  }
}
